import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';

import Layout from '../../../components/UI/Layout/Layout';
import MotorDataPhaseItems from '../../../components/MotorDataComponents/MotorDataPhaseItems/MotorDataPhaseItems';
import LocalizedStrings from '../../../assets/data/LocalizedStrings/LocalizedStrings.json';

class MotorDataPhasesPage extends Component {
  goBackHandler = () => {
    this.props.history.push('/');
  };

  render() {
    const {
      country,
      language,
      selectedUSA,
      selectedCanadaEN,
      selectedCanadaFR
    } = this.props;
    return (
      <Layout
        title={LocalizedStrings[language].motorData}
        clicked={this.goBackHandler}
        selectedCanadaEN={selectedCanadaEN}
        selectedCanadaFR={selectedCanadaFR}
        selectedUSA={selectedUSA}
        country={country}
        language={language}
      >
        <MotorDataPhaseItems country={country} language={language} />
      </Layout>
    );
  }
}

MotorDataPhasesPage.propTypes = {
  language: PropTypes.string.isRequired,
  country: PropTypes.string.isRequired,
  selectedCanadaEN: PropTypes.func,
  selectedCanadaFR: PropTypes.func,
  selectedUSA: PropTypes.func
};

export default withRouter(MotorDataPhasesPage);
